import React, { Component } from 'react';
import translate from '../../TranslateHOC';
import { connect } from 'react-redux';
import {resetAPIErrors } from '../../../actions';
import ErrorAlert from "./ErrorAlert";

class MyS4CAPIErrorAlert extends Component {

    componentWillUnmount() {

        if(this.props.errorType) {
            this.props.resetAPIErrors(this.props.errorType);
        }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps.curLang !== this.props.curLang) {

            if(this.props.errorType) {
                this.props.resetAPIErrors(this.props.errorType);
            }
        }
    }

    render() {
        const { errorMessage } = this.props;
        return (
            <ErrorAlert
                errorMessage={errorMessage}/>)
    }
}

export default translate(connect(null,{ resetAPIErrors })(MyS4CAPIErrorAlert));